import React, { Component } from 'react';
import { LoadingSpinner } from '../components/LoadingSpinner';

// Downloads the code of a component when it shows for the first time. react-dom 16.4 does not have React.lazy.
// load() returns a promise of the module. name is the export of the component.
export function asyncComponent(load, name) {
    let loadedComponent = null;

    return class AsyncComponent extends Component {
        state = {
            component: loadedComponent,
            failed: false
        };

        componentDidMount() {
            this.mounted = true;

            if (null === loadedComponent) {
                load().then((module) => {
                    loadedComponent = module[name];

                    if (this.mounted) {
                        this.setState({ component: loadedComponent });
                    }
                }).catch(() => {
                    if (this.mounted) {
                        this.setState({ failed: true });
                    }
                });
            }
        }

        componentWillUnmount() {
            this.mounted = false;
        }

        render() {
            const { component: LoadedComponent, failed } = this.state;

            if (failed) {
                return (
                    <div className="loading">Ocorreu um erro a carregar a página. Por favor, recarregue a página.</div>
                );
            }

            if (null === LoadedComponent) {
                return (
                    <LoadingSpinner />
                );
            }

            return (
                <LoadedComponent {...this.props} />
            );
        }
    };
}
